module.exports = __webpack_public_path__ + "img/machine-waypoint.7b727cd1.png";